import React, { Suspense } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import { theme } from '../theme/App.theme';
import { CssBaseline } from '@mui/material';
import createGenerateClassName from '@mui/styles/createGenerateClassName';
import StylesProvider from '@mui/styles/StylesProvider';
import { Provider as ReduxProvider } from 'react-redux';
import { store, persistor } from 'redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import PageRouting from 'pages/PageRouting/PageRouting';
import { ZipcodeListenerProvider } from 'components/Global/ZipcodeListenerProvider/ZipcodeListenerProvider';

const queryClient = new QueryClient();
const generateClassName = createGenerateClassName({
  productionPrefix: 'STJSS',
});

function AcuraApp() {
  return (
    <Suspense fallback={<></>}>
      <StylesProvider generateClassName={generateClassName}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ReduxProvider store={store}>
              <PersistGate persistor={persistor}>
                <QueryClientProvider client={queryClient}>
                  <ZipcodeListenerProvider />
                  <Router>
                    <PageRouting />
                  </Router>
                  <ReactQueryDevtools position="top-right" />
                </QueryClientProvider>
              </PersistGate>
            </ReduxProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </StylesProvider>
    </Suspense>
  );
}

export default AcuraApp;
